// hooks/useCouncilOverview.ts — effect-fetch the Council dashboard (display-only).
// Returns null until the first fetch resolves; consumers fall back to placeholders.

import { useEffect, useState } from 'react';
import { councilService, type CouncilOverview } from '@/core/services/councilService';

export function useCouncilOverview(): CouncilOverview | null {
  const [data, setData] = useState<CouncilOverview | null>(null);
  useEffect(() => {
    councilService.overview().then(setData).catch(() => {});
  }, []);
  return data;
}
